export default __webpack_public_path__ + "web/react/components/save-for-later-send-to-app-modal/images/s4l-image3.c0c52fe25ca3123148387825b49f5bfa.png";